@import "../../variables.scss";

.overflowedText {
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  padding-right: 0.5rem;
  cursor: default;
  white-space: nowrap;
}

.overflowedText__tooltip {
  display: none;
  width: 400px;
  z-index: 100;
  @media (max-width: $size-sm) {
    width: 300px;
  }
  white-space: pre-line;
}

.overflowedText__arrow {
  display: none;
}

.overflowedText:hover .overflowedText__tooltip {
  display: block;
  position: absolute;
  margin-left: 1rem;
  font-size: 12px;
  background-color: #001e53;
  color: white;
  padding: 2px 4px;
  border-radius: 6px;
}

.overflowedText:hover .overflowedText__arrow {
  display: block;
  position: absolute;
  width: 0;
  height: 0;
  margin-left: 1.3rem;
  margin-top: -3px;
  z-index: 999;
  border-left: 7px solid transparent;
  border-right: 7px solid transparent;
  border-bottom: 5px solid #001e53;
}
